module.exports = __webpack_public_path__ + "static/JL.190207.COH.WEBW.Gallery3-8506de5cff50ac5db96a0ef54e0914bb.jpg";